import Vue from 'vue'

import Router from 'vue-router'
import Index from './index'
import Data from './data'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}
Vue.use(Router)
// console.log(Data)
export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
      ...Data,
        ...Index,
    ]
})